import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../server/graphql/__generated.types';

const defaultOptions = {} as const;
export type RequestCancelClipRenderingMutationVariables = Types.Exact<{
  inputs: Types.RequestCancelClipRenderingInputs;
}>;

export type RequestCancelClipRenderingMutation = {
  __typename?: 'Mutation';
  requestCancelClipRendering: {
    __typename?: 'RequestCancelClipRenderingMutationResponse';
    code: string;
    success: boolean;
    message: string;
  };
};

export const RequestCancelClipRenderingDocument = gql`
  mutation requestCancelClipRendering($inputs: RequestCancelClipRenderingInputs!) {
    requestCancelClipRendering(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type RequestCancelClipRenderingMutationFn = Apollo.MutationFunction<
  RequestCancelClipRenderingMutation,
  RequestCancelClipRenderingMutationVariables
>;

/**
 * __useRequestCancelClipRenderingMutation__
 *
 * To run a mutation, you first call `useRequestCancelClipRenderingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCancelClipRenderingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCancelClipRenderingMutation, { data, loading, error }] = useRequestCancelClipRenderingMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useRequestCancelClipRenderingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestCancelClipRenderingMutation,
    RequestCancelClipRenderingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestCancelClipRenderingMutation,
    RequestCancelClipRenderingMutationVariables
  >(RequestCancelClipRenderingDocument, options);
}
export type RequestCancelClipRenderingMutationHookResult = ReturnType<
  typeof useRequestCancelClipRenderingMutation
>;
export type RequestCancelClipRenderingMutationResult =
  Apollo.MutationResult<RequestCancelClipRenderingMutation>;
export type RequestCancelClipRenderingMutationOptions = Apollo.BaseMutationOptions<
  RequestCancelClipRenderingMutation,
  RequestCancelClipRenderingMutationVariables
>;
